import { render, staticRenderFns } from "./ReviewCriteriaSettingsController.vue?vue&type=template&id=5e64417e&"
import script from "./ReviewCriteriaSettingsController.vue?vue&type=script&lang=js&"
export * from "./ReviewCriteriaSettingsController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports